import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { FooterContainer, FooterText } from './timeline-styles';
import type { FooterItem, TimelineFooterProps } from './timeline-types';

const isFooterItemArray = (children: TimelineFooterProps['children']): children is readonly FooterItem[] => {
    return (
        is.array(children) &&
        is.nonEmptyArray(children) &&
        children.every((item) => is.plainObject(item) && 'key' in item && 'content' in item)
    );
};

export const TimelineFooter: FunctionComponent<TimelineFooterProps> = ({ children, className }) => {
    if (is.string(children)) {
        return (
            <FooterContainer className={className}>
                <FooterText>{children}</FooterText>
            </FooterContainer>
        );
    }

    if (isFooterItemArray(children)) {
        return (
            <FooterContainer className={className}>
                {children.map((item) => (
                    <FooterText key={item.key}>{item.content}</FooterText>
                ))}
            </FooterContainer>
        );
    }

    return <FooterContainer className={className}>{children}</FooterContainer>;
};
